import { SearchCircle } from "pages/[tenant]/console/assets/icons/sidebarSection/appstore/SearchCircle";
import { WebhookHistoryIcon } from "pages/[tenant]/console/assets/icons/sidebarSection/appstore/WebhookHistoryIcon";
import { WebhooksIcon } from "pages/[tenant]/console/assets/icons/sidebarSection/appstore/WebhooksIcon";
import {
  IOption,
  IOptionsHook,
  ISubSection,
} from "pages/[tenant]/console/types";

import { useAuthContext } from "shared/utils/hooks/useAuthContext";
import { useFeature } from "shared/utils/hooks/useFeature";

import ConsoleTemplateIcon from "@Console/assets/icons/sidebarSection/config/ConsoleTemplateIcon";
import { TagsIcon } from "@Console/assets/icons/sidebarSection/pages/TagsIcon";

export const useAppStoreOptions = (): IOptionsHook => {
  const isMonetizzeEnabled = useFeature("f_monetizze_integration");
  const isHotMartEnabled = useFeature("f_hotmart_integration");
  const isTictoEnabled = useFeature("f_ticto_integration");
  const isKiwifyEnabled = useFeature("f_kiwify_integration");
  const isNotazzEnabled = useFeature("f_notazz");

  const isEmailCampaignEnabled = useFeature("f_campaigns");
  const isNotificationsCampaignEnabled = useFeature("f_campaigns_notification");

  const shouldHideEmailCampaignMenuItem =
    !isEmailCampaignEnabled && !isNotificationsCampaignEnabled;

  const { rolesUser } = useAuthContext();

  const isExternalCheckoutEnabled =
    isMonetizzeEnabled || isHotMartEnabled || isTictoEnabled || isKiwifyEnabled;

  const hasPermission = (permissionsList: string[]): boolean =>
    rolesUser?.some((permission) => permissionsList?.includes(permission));

  const sectionLabel = "App Store";
  const appStore: IOption[] = [];
  const appStoreSubSections: ISubSection[] = [
    {
      label: "Webhooks",
      options: [
        {
          id: 20,
          label: "Webhooks",
          description:
            "Automatize fluxos e processos com o envio de informações em tempo real",
          path: "/console/webhooks",
          icon: <WebhooksIcon />,
          shouldHide: !hasPermission(["visualizar-webhook"]),
        },
        {
          id: 21,
          label: "Históricos de disparos",
          description:
            "Confira o histórico de disparos de webhooks e reenvie payloads da suas informações.",
          path: "/console/webhooks/history",
          icon: <WebhookHistoryIcon />,
          shouldHide: !hasPermission(["visualizar-historico-de-envios"]),
        },
      ],
    },
    {
      label: "Pixel",
      options: [
        {
          id: 30,
          label: "Pixel de Rastreamento",
          description:
            "Colete informações que auxiliam na mensuração o desempenho das suas campanhas.",
          path: "/console/pixel",
          icon: <SearchCircle />,
          shouldHide: !hasPermission(["visualizar-pixel-de-rastreamento"]),
        },
      ],
    },
    {
      label: "Entregas",
      options: [
        {
          id: 40,
          label: "Checkouts externos",
          description: "",
          path: "/console/delivery",
          icon: <TagsIcon />,
          shouldHide:
            !isExternalCheckoutEnabled ||
            !hasPermission(["visualizar-configuracoes-de-integracao"]),
        },
        {
          id: 41,
          label: "Log de notificações",
          description: "",
          path: "/console/delivery/logs",
          icon: <WebhookHistoryIcon />,
          shouldHide: true,
        },
      ],
    },
    {
      label: "Integrações",
      options: [
        {
          icon: <TagsIcon />,
          id: 50,
          label: "Notazz",
          path: "/console/integrations/notazz",
          shouldHide:
            !isNotazzEnabled ||
            !hasPermission(["visualizar-configuracoes-de-emissao"]),
        },
      ],
    },
    {
      label: "Notificações",
      options: [
        {
          id: 60,
          label: "Campanhas",
          description: "",
          path: "/console/campaign-templates",
          icon: <ConsoleTemplateIcon />,
          shouldHide: shouldHideEmailCampaignMenuItem,
        },
      ],
    },
  ];

  return {
    options: appStore,
    subSections: appStoreSubSections,
    label: sectionLabel,
  };
};
